///thirdpartyhmrc/urlauth
export const HMRC_URL_AUTH = "HMRC_URL_AUTH";
export const HMRC_URL_AUTH_SUCCESS = "HMRC_URL_AUTH_SUCCESS";
export const HMRC_URL_AUTH_FAILURE = "HMRC_URL_AUTH_FAILURE";
///thirdpartyhmrc/generateaccesstoken
export const HMRC_GENERATE_ACCESS_TOKEN = "HMRC_GENERATE_ACCESS_TOKEN";
export const HMRC_GENERATE_ACCESS_TOKEN_SUCCESS =
  "HMRC_GENERATE_ACCESS_TOKEN_SUCCESS";
export const HMRC_GENERATE_ACCESS_TOKEN_FAILURE =
  "HMRC_GENERATE_ACCESS_TOKEN_FAILURE";
